import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import MainLayout from "../components/Layout/MainLayout";
import Website from "../pages/website"; 

/* Page title handler */
const CurrentPath = () => {
  const location = useLocation();

  useEffect(() => {
    document.title = " Bit Wave Capital";
  }, [location]);

  return null;
};

const Router = () => {
  return (
    <BrowserRouter>
      <CurrentPath />

      <Routes>
        {/* 👇 MAIN LAYOUT */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Website />} /> 
        </Route>
      </Routes>

    </BrowserRouter>
  );
};

export default Router;
